module.exports = __webpack_public_path__ + "img/thierry-circle.41ffc4d3.jpg";